import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SocketProvider } from '@providers/SocketProvider';
import { Layout } from '@components/layout/Layout';
import { RoomManager } from '@components/room/RoomManager';
import { Room } from '@components/room/Room';
import { useRoomStore } from '@store/roomStore';
import './styles/global.css';

function App() {
  const roomCode = useRoomStore((state) => state.roomCode);
  
  return (
    <SocketProvider>
      <Router>
        <Layout>
          <Routes>
            <Route 
              path="/" 
              element={
                roomCode ? <Navigate to={`/room/${roomCode}`} /> : <RoomManager />
              } 
            />
            <Route path="/room/:code" element={<Room />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      </Router>
    </SocketProvider>
  );
}

export default App;